import { RootState } from 'app/store';
import { gameRewardsAdapter, gamesAdapter } from './games.adapter';

export const {
  selectAll: selectRewards,
  selectById: selectRewardById,
  selectTotal: selectRewardsTotal,
} = gameRewardsAdapter.getSelectors(({ games }: RootState) => games.current.form.rewardEntities);

export const {
  selectAll: selectGames,
  selectById: selectGameById,
  selectTotal: selectGamesTotal,
} = gamesAdapter.getSelectors(({ games }: RootState) => games.list);

export const gameListSelector = ({ games }: RootState) => games.list;

export const currentGameSelector = ({ games }: RootState) => games.current;

export const isFormValidSelector = ({ games }: RootState) => games.current.isStepValid;

export const selectedGameSelector = ({ games }: RootState) => games.selected;

export const selectedGameRewardsSelector = ({ games }: RootState) => games.selected.rewards;
